<template lang="pug">
  #program-steps-chart
    WtTitle(card-title) Sitewide Averages Over Time
    LineChart(
      v-if="loadedStatus && !_.isEmpty(data)"
      :chart-data="chartData"
      showLegend
    )
    .empty-state(v-if="_.isEmpty(data)")
      p Hey there,
      br
      p A chart will show here when data is available.
</template>

<script>
import { mapGetters } from "vuex";
import WtTitle from "@@/WtTitle/WtTitle";
import LineChart from "@/charts/LineChart";
import analyticsTrackingMixin from "@/mixins/analyticsTrackingMixin";

export default {
  name: "ProgramStepsChart",

  components: {
    LineChart,
    WtTitle
  },
  mixins: [analyticsTrackingMixin],

  props: {
    data: {
      type: Array,
      default: null
    },

    loadedStatus: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters("program", ["coreProgramMeta"]),

    chartData() {
      const labels = this.data.map(month => month.month).reverse();
      const stepData = this.data.map(month => month.averageSteps).reverse();
      const activityData = this.data
        .map(month => month.averageActivities)
        .reverse();

      const colors = this._app_chart_two_color;

      const datasets = [
        {
          label: "Average Steps",
          borderColor: colors.steps,
          backgroundColor: colors.stepslight,
          data: stepData
        }
      ];
      // Only Show Activities if the ActivityConverter is enabled.
      if (this.coreProgramMeta.converter) {
        datasets.push({
          label: "Average Activities",
          borderColor: colors.activities,
          backgroundColor: colors.activitieslight,
          data: activityData
        });
      }

      return { labels, datasets };
    }
  },
  mounted() {
    this.trackFeatureView("sitewide", "sitewide_chart");
  }
};
</script>

<style lang="sass" scoped>
#program-steps-chart
  min-height: 200px
</style>
